<!--
 * @Description: 个税详情组件
 * @Author: sunhuihong
 * @Date: 2025-11-07 12:43:52
-->
<template>
  <el-dialog width="1070px" center title="个税详情" :visible.sync="visible" :close-on-click-modal="false"
    @open="initData" :before-close="handleCancel">
    <div class="income-tax-details-body">
      <el-table style="margin: 15px 0 50px 0;" ref="table" :data="dataTable" 
        :header-cell-style="{'background-color': '#EFF5FA'}" max-height="300">
        <el-table-column label="姓名" min-width="15%" align="left">
          <template slot-scope="scope">
            <span>{{scope.row.name}}</span>
            <span v-if="scope.row.mobile">{{maskPhoneNumber(scope.row.mobile)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="withdraw.applyTime" label="提现时间" min-width="15%" align="left"></el-table-column>
        <el-table-column label="提现金额(元)" min-width="15%" align="left">
          <template slot-scope="scope">
            <span>{{scope.row.withdraw.appliedAmountYuan}}</span>
            <el-popover placement="right-start" title="" width="628" trigger="click">
              <income-item-list :incomeItemList="incomeItemList"/>
              <span slot="reference" class="withdrawal-amount-details"
                @click="handleDetails(scope.row)">
                明细
              </span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="withdraw.taxPayableYuan" label="应交税(元)" min-width="14%" align="left"></el-table-column>
        <el-table-column prop="withdraw.actualTaxYuan" label="实交税(元)" min-width="13%" align="left"></el-table-column>
        <el-table-column prop="withdraw.amountYuan" label="实际到账(元)" min-width="13%" align="left"></el-table-column>
        <el-table-column prop="withdraw.noTaxReason" label="备注" min-width="15%" align="left"></el-table-column>
      </el-table>
      <div class="dialog-footer bk-wizard-bottons">
        <el-button @click="handleCancel">关 闭</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Constant from '@/global/Constant.js'
import Util from '@/global/Util.js'
import IncomeItemList from './IncomeItemList.vue'
export default {
  name: 'IncomeTaxItemList',

  props: ["visible", "incomeTaxParams"],

  components: {
    'income-item-list': IncomeItemList
  },

  data() {
    return {
      dataTable: [],
      incomeItemList: [],
    }
  },

  methods: {
    initData() {
      let header = this.encryptionUtil.signatureParams(this.incomeTaxParams,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_GET_LIST_INCOME_TAXI_ITEMS,
        param: this.incomeTaxParams,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return;
        }
        this.dataTable = result.data;
      });
    },

    maskPhoneNumber(mobile) {
      return Util.maskPhoneNumber(mobile);
    },

    handleDetails(row) {
      let params= {withdrawId: row.withdraw.id};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_GET_LIST_INCOMEI_ITEMS,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return;
        }
        this.incomeItemList = result.data;
      });
    },

    handleCancel() {
      this.$emit("close-dialog");
    }
  },
}
</script>

<style scoped>
.income-tax-details-body {
  padding: 0 25px;
}

.withdrawal-amount-details {
  cursor: pointer;
  font-weight: 400;
  font-size: 14px;
  color: #3E7EF5;
}

.dialog-footer {
  text-align: center;
}

.bk-wizard-bottons {
  padding: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/finance/components/incometaxlist/IncomeTaxItemList.vue